module.exports = new __parcel__URL__("CreditCardIcon.d064c319.svg").toString();